import { ReactNode, useEffect, useMemo, useRef } from "react";
import { motion, useAnimate } from "framer-motion";
import { useResponsiveMobile } from "../../../hooks/useResponsiveMobile";

type CardItem = {
  title: ReactNode | string;
  content: ReactNode;
  content2?: string | ReactNode;
  src: string;
};

const Card = ({
  title,
  content,
  content2,
  src,
}: {
  title: string | ReactNode;
  content: ReactNode;
  content2?: string | ReactNode;
  src: string;
}) => {
  const isMobile = useResponsiveMobile(900);
  return (
    <motion.div
      className="benefit-card flex flex-row md:gap-8 w-full md:max-w-[450px] min-w-[160px] md:w-full md:h-[500px] bg-[#F2F4F8] rounded-[24px]"
      initial={false}
      whileHover={isMobile ? undefined : { scale: 1.03, rotateZ: 1, y: -2 }}
      transition={{ type: "spring", stiffness: 260, damping: 18, mass: 0.6 }}
      style={{
        transformStyle: "preserve-3d",
        willChange: "transform",
      }}
    >
      <div className="flex flex-col gap-3 md:gap-6 px-6 py-8 md:p-10 justify-between w-full">
        <div className="flex flex-col gap-3">
          <div className="flex flex-col gap-3 md:gap-6">
            <span className="font-bold md:font-bold text-[18px] md:text-heading1_2">{title}</span>
            {content}
          </div>

          {content2 && (
            <span className="font-boid v text-[14px] md:text-[18px] text-[#0079FF] leading-[1.5]">
              {content2}
            </span>
          )}
        </div>

        <div className="md:w-24 md:h-24 h-12 w-12 flex self-end">
          <img className="self-end w-full h-full" src={src} alt="card" />
        </div>
      </div>
    </motion.div>
  );
};

export default Card;

const chunk2 = <T,>(arr: T[]) => {
  const out: T[][] = [];
  for (let i = 0; i < arr.length; i += 2) out.push(arr.slice(i, i + 2));
  return out;
};

export const Section5 = () => {
  const isMobile = useResponsiveMobile(900);
  const [scope, animate] = useAnimate();

  // ===== 카드 데이터 =====
  const cards: CardItem[] = [
    // {
    //   src: "/assets/images/serviceIntro/card1.png",
    //   title: "정산 업무 자동화",
    //   content: (
    //     <span className="text-[#4D4F58] font-normal text-[14px] md:text-[18px]">
    //       반복되는 정산 업무 <br />
    //       자동화를 통해 시간과 {isMobile && <br />} 비용을 절약
    //     </span>
    //   ),
    // },
    // {
    //   src: "/assets/images/serviceIntro/card2.png",
    //   title: "결제 통합 조회",
    //   content: (
    //     <span className="text-[#4D4F58] font-normal text-[14px] md:text-[18px]">
    //       여러 개로 흩어진 결제 {isMobile && <br />} 데이터를
    //       {!isMobile && <br />} 한 곳에 모아 {isMobile && <br />} 돈의 흐름을
    //       한눈에 관리
    //     </span>
    //   ),
    // },
    // {
    //   src: "/assets/images/serviceIntro/card3.png",
    //   title: "실시간 정산",
    //   content: (
    //     <span className="text-[#4D4F58] font-normal text-[14px] md:text-[18px]">
    //       정산 대금을 10분 이내로
    //       <br />
    //       빠르게 지급 받아 유연한 {isMobile && <br />} 자금 흐름
    //     </span>
    //   ),
    // },
    // {
    //   src: "/assets/images/serviceIntro/card4.png",
    //   title: "영업대행 관리 통합",
    //   content2: "*모바일 서비스 (앱) 지원",
    //   content: (
    //     <span className="text-[#4D4F58] font-normal text-[14px] md:text-[18px]">
    //       {isMobile ? (
    //         <>
    //           영업 대행 업무까지 <br />
    //           시스템 통합 지원
    //         </>
    //       ) : (
    //         <>
    //           파트너 매장과의 거래,
    //           <br />
    //           실시간 수수료 계산 등 <br />
    //           영업 대행 업무까지 시스템 통합 지원
    //         </>
    //       )}
    //     </span>
    //   ),
    // },
    // {
    //   src: "/assets/images/serviceIntro/card5.png",
    //   title: "파트너사 매장 지원",
    //   content2: "*모바일 서비스 (앱) 지원",
    //   content: (
    //     <span className="text-[#4D4F58] font-normal text-[14px] md:text-[18px]">
    //       {isMobile ? (
    //         <>
    //           결제내역, 예상 입금액, <br />
    //           세금계산서 발행 등 <br />
    //           필요한 정보 제공
    //         </>
    //       ) : (
    //         <>
    //           가맹점에게 결제내역, 예상 입금액,
    //           <br />
    //           세금계산서 발행 등 필요한 정보 제공
    //         </>
    //       )}
    //     </span>
    //   ),
    // },
    // {
    //   src: "/assets/images/serviceIntro/card6.png",
    //   title: "맞춤화된 서비스",
    //   content: (
    //     <span className="text-[#4D4F58] font-normal text-[14px] md:text-[18px]">
    //       우리 회사만의 특별한 정산 규칙에 맞춰
    //       <br />
    //       기능을 유연하게 설정 및 사용 가능
    //     </span>
    //   ),
    // },
    // {
    //   src: "/assets/images/serviceIntro/card7.png",
    //   title: "확장 가능한 안정성",
    //   content: (
    //     <span className="text-[#4D4F58] font-normal text-[14px] md:text-[18px]">
    //       사용량 기반 요금제로
    //       <br />
    //       비즈니스 성장에 따라
    //       <br />
    //       안정적으로 확장 가능
    //     </span>
    //   ),
    // },
    {
      src: "/assets/images/serviceIntro/card1.png",
      title: (
        <>
          정산 프로세스 <br />
          자동화와 운영 안정성
        </>
      ),
      content: (
        <span className="text-[#4D4F58] font-normal text-[16px] md:text-[18px] leading-[1.5]">
          분산된 PG/VAN사 데이터를 통합하고, 정산금 산정부터 {isMobile && <br />}지급 대행까지 전
          과정을 시스템으로 자동화
        </span>
      ),
      content2: (
        <>
          #시간·비용절약 <br />
          #운영리스크차단 
        </>
      ),
    },
    {
      src: "/assets/images/serviceIntro/card7.png",
      title: (
        <>
          비즈니스 맞춤형 <br />
          정산 유연성
        </>
      ),
      content: (
        <span className="text-[#4D4F58] font-normal text-[16px] md:text-[18px] leading-[1.5]">
          고객사의 플랫폼 구조 및 파트너 유형에 맞춰 {isMobile && <br />}
          최적화된 정산 정책과 결제 프로세스를 설계
        </span>
      ),
      content2: (
        <>
          #바로 비즈니스 시작! <br />
          #최적화 환경 조성
        </>
      ),
    },
    {
      src: "/assets/images/serviceIntro/card3.png",
      title: (
        <>
          선/실시간 정산을 <br />
          통한 상생 구조
        </>
      ),
      content: (
        <span className="text-[#4D4F58] font-normal text-[16px] md:text-[18px] leading-[1.5]">
          카드사 정산일(D+3)보다 빠른 {isMobile && <br />}
          선정산(D+1) 및 실시간 정산으로 가맹점 자금 회전을 도움
        </span>
      ),
      content2: (
        <>
          #바로 정산 <br />
          #자금유동성 개선
        </>
      ),
    },
    {
      src: "/assets/images/serviceIntro/card5.png",
      title: (
        <>
          별도 구축 없이 도입하는 <br />
          파트너 전용 서비스
        </>
      ),
      content: (
        <span className="text-[#4D4F58] font-normal text-[16px] md:text-[18px] leading-[1.5]">
          가맹점의 실시간 입금 조회부터 영업대행사의 {isMobile && <br />} 수수료 관리까지, 즉시
          연동가능한 전용 페이지 제공
        </span>
      ),
      content2: (
        <>
          #인프라 구축 비용 절감 <br />
          #관리 효율성 증대
        </>
      ),
    },
  ];

  const rows = useMemo(() => chunk2(cards), [cards]);

  //  모바일: 헤더 블록 스크롤 등장 추가
  const headerRef = useRef<HTMLDivElement | null>(null);
  const ranHeader = useRef(false);

  // row wrapper ref들
  const rowRefs = useRef<(HTMLDivElement | null)[]>([]);
  const ranRows = useRef<Record<number, boolean>>({}); // row별 1회 실행

  useEffect(() => {
    if (!isMobile) return;

    ranHeader.current = false;
    ranRows.current = {};

    let alive = true;

    // (1) 헤더 등장
    const ioHeader = new IntersectionObserver(
      ([entry]) => {
        if (!alive) return;
        if (!entry?.isIntersecting) return;
        if (ranHeader.current) return;
        ranHeader.current = true;

        // 헤더 안 요소들 순차 등장(가볍게)
        animate(
          ".m-s5-header",
          { opacity: 1, y: 0, scale: 1 },
          { duration: 0.85, ease: [0.22, 1, 0.36, 1] },
        );

        ioHeader.disconnect();
      },
      {
        threshold: 0,
        rootMargin: "0px 0px -40% 0px", //  60% 자좀
      },
    );

    if (headerRef.current) ioHeader.observe(headerRef.current);

    // (2) row(2개씩) 등장 — 기존 유지
    const ioRows = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!alive) return;
          if (!entry.isIntersecting) return;

          const idx = Number((entry.target as HTMLElement).dataset.row);
          if (ranRows.current[idx]) return;
          ranRows.current[idx] = true;

          animate(
            `.m-row-${idx} .benefit-card`,
            { opacity: 1, y: 0, scale: 1 },
            { duration: 0.55, ease: [0.22, 1, 0.36, 1] },
          );

          ioRows.unobserve(entry.target);
        });
      },
      {
        threshold: 0,
        rootMargin: "0px 0px -40% 0px",
      },
    );

    rowRefs.current.forEach((el) => el && ioRows.observe(el));

    return () => {
      alive = false;
      ioHeader.disconnect();
      ioRows.disconnect();
    };
  }, [animate, rows.length, isMobile]);

  // ===== PC용 기존 로직(원래 코드) =====
  const col1Ref = useRef<HTMLDivElement | null>(null);
  const col2Ref = useRef<HTMLDivElement | null>(null);
  const ranCol1 = useRef(false);
  const ranCol2 = useRef(false);

  useEffect(() => {
    if (isMobile) return;
    let alive = true;

    const runCol = async (col: 1 | 2) => {
      if (!alive) return;
      await animate(
        `.col${col} .benefit-card`,
        { opacity: 1, y: 0, scale: 1 },
        { duration: 0.55, ease: [0.22, 1, 0.36, 1] },
      );
    };

    const io1 = new IntersectionObserver(
      ([entry]) => {
        if (!entry?.isIntersecting) return;
        if (ranCol1.current) return;
        ranCol1.current = true;
        runCol(1);
      },
      { threshold: 0, rootMargin: "-50% 0px -50% 0px" },
    );

    const io2 = new IntersectionObserver(
      ([entry]) => {
        if (!entry?.isIntersecting) return;
        if (ranCol2.current) return;
        ranCol2.current = true;
        runCol(2);
      },
      { threshold: 0, rootMargin: "-50% 0px -50% 0px" },
    );

    if (col1Ref.current) io1.observe(col1Ref.current);
    if (col2Ref.current) io2.observe(col2Ref.current);

    return () => {
      alive = false;
      io1.disconnect();
      io2.disconnect();
    };
  }, [animate, isMobile]);

  return (
    <section className="flex flex-col w-full justify-center items-center">
      {isMobile ? (
        //  모바일: 2열 grid + 2개씩(row) 같이 등장 + 헤더도 등장
        <div ref={scope} className="flex flex-col gap-[60px] w-full max-w-[1600px]">
          {/*  헤더: 처음엔 숨김 상태로 두고, 스크롤에서 animate로 등장 */}
          <div ref={headerRef} className="flex flex-col gap-10 self-center">
            <div className="flex flex-col gap-3">
              <span
                className="m-s5-header text-[#0079FF] text-[20px] font-normal text-center"
                style={{
                  opacity: 0,
                  transform: "translateY(18px) scale(0.98)",
                }}
              >
                Key Features
              </span>
              <span
                className="m-s5-header font-bold text-[36px] text-[#121319] text-center"
                style={{
                  opacity: 0,
                  transform: "translateY(18px) scale(0.98)",
                }}
              >
                품의 핵심 가치
              </span>
            </div>
          </div>

          <div className="w-full px-6">
            <div className="flex flex-col gap-4 w-full">
              {rows.map((pair, rowIdx) => (
                <div
                  key={`m-row-${rowIdx}`}
                  data-row={rowIdx}
                  ref={(el) => {
                    rowRefs.current[rowIdx] = el;
                  }}
                  className={`m-row-${rowIdx} flex flex-col md:grid md:grid-cols-2 gap-4`}
                >
                  {pair.map((c) => (
                    <Card
                      key={`${rowIdx}-${c.title}`}
                      src={c.src}
                      title={c.title}
                      content={c.content}
                      content2={c.content2}
                    />
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>
      ) : (
        //  PC: 기존 1열/2열 애니메이션 유지
        <div
          ref={scope}
          className="flex flex-col gap-20 w-full max-w-[1600px] md:px-8 md:justify-between items-center max-w-[1600px]"
        >
          <div className="flex flex-col gap-6 md:w-[343px]">
            <span className="font-normal text-[#0079FF] text-[18px] text-center">Key Benefits</span>
            <span className="font-bold text-display text-center">품의 핵심 가치</span>
          </div>
          <div className="grid grid-cols-4 max-[1320px]:grid-cols-[repeat(2,minmax(0,450px))] max-[1320px]:justify-center gap-8 w-full justify-items-center">
            <Card {...cards[0]} />
            <Card {...cards[1]} />
            {/* <Card {...cards[2]} /> */}

            <Card {...cards[2]} />
            <Card {...cards[3]} />
            {/* <Card {...cards[5]} />
            <Card {...cards[6]} /> */}
          </div>
        </div>
      )}
    </section>
  );
};
